// ./exportTariffFullExcelStrict.js
import XLSX from "xlsx-js-style";

const border = {
  top:{style:"thin",color:{rgb:"FFBFBFBF"}},
  right:{style:"thin",color:{rgb:"FFBFBFBF"}},
  bottom:{style:"thin",color:{rgb:"FFBFBFBF"}},
  left:{style:"thin",color:{rgb:"FFBFBFBF"}},
};

const sHeader = { font:{bold:true}, alignment:{horizontal:"center",vertical:"center",wrapText:true}, fill:{fgColor:{rgb:"FFF2F2F2"}}, border };
const sCell   = { alignment:{vertical:"center",wrapText:true}, border };
const sNum    = { ...sCell, alignment:{horizontal:"right",vertical:"center"}, numFmt: "#,##0" };
const sMoney  = { ...sNum, numFmt: "#,##0.00" };

const COLS = [
  { k:"id",               t:"id",                              s:sCell  },
  { k:"researchCode",     t:"Код исследования",                s:sCell  },
  { k:"inconsistenceQty", t:"Количество с\nнесоответствием",   s:sNum   },
  { k:"contractName",     t:"Договор",                         s:sCell  },
  { k:"filial",           t:"Филиал",                          s:sCell  },
  { k:"filialDivision",   t:"Районное отделение",              s:sCell  },
  { k:"laboratory",       t:"Лаборатория",                     s:sCell  },
  { k:"department",       t:"Отдел",                           s:sCell  },
  { k:"group",            t:"Группа",                          s:sCell  },
  { k:"subGroup",         t:"Подгруппа",                       s:sCell  },
  { k:"method",           t:"Метод",                           s:sCell  },
  { k:"reportMonth",      t:"Отчётный месяц",                  s:sCell  },
  { k:"quantity",         t:"Количество",                      s:sNum   },
  { k:"price",            t:"Цена",                            s:sMoney },
  { k:"weightCoeff",      t:"Весовой коэффициент",             s:sMoney },
  { k:"sum",              t:"Сумма",                           s:sMoney },
];

const get = (o,p)=>p.split(".").reduce((a,k)=>a?.[k],o);
const pad = (n)=>String(n).padStart(2,"0");
const ddmmyyyy = (d)=>{
  if(!d) return "";
  const dt = typeof d==="string" ? new Date(d) : d;
  return `${pad(dt.getDate())}.${pad(dt.getMonth()+1)}.${dt.getFullYear()}`;
};

/** Принимает результат calculateTarficiationGroups(...) */
export function exportTariffFullExcelStrict(grouped, ctx={}) {
  const periodStr = ddmmyyyy(ctx?.period2);
  let rowNo = 1;

  const aoa = [];
  aoa.push(COLS.map(c=>({ v:c.t, s:sHeader })));

  const pushRow = (ctxRow, grp, rcg) => {
    const ts = rcg.totalSummary || {};

    debugger;
    // контекстные значения (с надёжными fallback-ами)
    const contractName   = ctxRow.contractName   ?? "";
    const filial         = ctxRow.filial         ?? "";
    const filialDivision = ctxRow.filialDivision ?? "";
    const laboratory     = ctxRow.laboratory     ?? "";
    const department     = ctxRow.department     ?? "";
    const groupName      = get(grp,"first.group.name") ?? ctxRow.groupName ?? "";

    // «полевые» из rcg.first.*
    const subGroup    = get(rcg,"first.subGroup.name") || "";
    const method      = get(rcg,"first.method.name")   || "";

    const row = {
      id:              rcg.first?.id ?? ts.idx ?? rowNo,
      researchCode:    ts.researchCode || "",
      inconsistenceQty:Number(ts.inconsistenceQuantity ?? 0),
      contractName,
      filial,
      filialDivision,
      laboratory,
      department,
      group:           groupName,
      subGroup,
      method,
      reportMonth:     periodStr,
      quantity:        Number(ts.quantity ?? 0),
      price:           Number(ts.baseValue ?? 0),
      weightCoeff:     Number(ts.weightCoefficient ?? 0),
      sum:             Number(ts.summary ?? 0),
    };

    aoa.push(COLS.map(c=>({ v: row[c.k] ?? (c.s===sNum||c.s===sMoney?0:""), s:c.s })));
    rowNo++;
  };

  (grouped||[]).forEach(departmentGroup=>{
    debugger;
    const departmentRow = {
      contractName:   get(departmentGroup,"first.contractName"),
      filial:         get(departmentGroup,"first.filialName"),
      filialDivision: get(departmentGroup,"first.filialDivisionName"),
      laboratory:     get(departmentGroup,"first.division.name"),
      department:     get(departmentGroup,"first.department.name"),
    };

    // division → group → researchCodeGroups
    (departmentGroup.divisionGroups||[]).forEach(divisionGroup=>{
      const divisionRow = {
        ...departmentRow,
        laboratory: get(divisionGroup,"first.division.name") ?? departmentRow.division?.name,
      };

      (divisionGroup.groupGroups||[]).forEach(group=>{
        (group.researchCodeGroups||[]).forEach(researchCodeGroup=>{
          pushRow(divisionRow, group, researchCodeGroup);
        });
      });
    });

    // на случай если у dept есть groupGroups без divisionGroups
    (departmentGroup.groupGroups||[]).forEach(group=>{
      (group.researchCodeGroups||[]).forEach(researchCodeGroup=>{
        pushRow(departmentRow, group, researchCodeGroup);
      });
    });
  });

  const ws = XLSX.utils.aoa_to_sheet(aoa);
  ws["!rows"] = [{ hpt: 42 }];

  // автоширина
  const ref = ws["!ref"];
  if (ref) {
    const range = XLSX.utils.decode_range(ref);
    const widths = [];
    for (let c = range.s.c; c <= range.e.c; c++) {
      let max = 10;
      for (let r = range.s.r; r <= range.e.r; r++) {
        const cell = ws[XLSX.utils.encode_cell({ r, c })];
        const text = cell?.v == null ? "" : String(cell.v);
        const len = Math.min(80, Math.ceil(text.length * 1.1) + 2);
        if (len > max) max = len;
      }
      widths.push(max);
    }
    ws["!cols"] = widths.map((wch)=>({ wch }));
  }

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Отчёт");
  const out = XLSX.write(wb, { type:"array", bookType:"xlsx" });
  const blob = new Blob([out], { type:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

  const name = `Тарификатор, ${ctx?.period1?ddmmyyyy(ctx.period1):""}–${periodStr}.xlsx`;
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = name;
  document.body.appendChild(a); a.click(); a.remove();
  URL.revokeObjectURL(url);
}


